import React from "react";

export function AppHeader() {

    return <div id="trueHeader">
        <div className="wrapper">
            <div className="container">
                <div id="root"/>
                <div className="logo"><a href="https://www.sistemx.ba" id="logo"></a></div>
            </div>
        </div>
    </div>

}